const risksRoot = ['risks'] as const;

/**
 * Serializable params for `GET /api/risks`. Backend owns search/filter/sort/pagination; these are forwarded as query params.
 */
export type RisksTableListParams = {
  page: number;
  pageSize: number;
  search: string;
  filterLevel: string;
  filterCategory: string;
  filterControlsMapped: string;
  filterProcessMapped: string;
  filterProcess: string;
  filterCycle: string;
  filterSource: string;
  sortKey: string | null;
  sortDir: 'asc' | 'desc';
  auditYearId: string | null;
};

export const risksQueryKeys = {
  all: risksRoot,
  dataset: () => [...risksRoot, 'dataset'] as const,
  dashboard: () => [...risksRoot, 'dashboard'] as const,
  list: (params: RisksTableListParams) => [...risksRoot, 'list', params] as const,
  detail: (riskId: string, auditYearId?: string | null) => [...risksRoot, 'detail', riskId, auditYearId ?? null] as const,
  processFilterOptions: () => [...risksRoot, 'process-filter-options'] as const,
  controlFilterOptions: (classification = 'business') =>
    [...risksRoot, 'control-filter-options', classification] as const,
} as const;
